import { createSelector } from '@ngrx/store';
import { createProfileState } from '../reducers/profile.reducer';
import { getIsPaperlessEnrollable } from '../../util/profile.util';

export const selectProfileResidenceState = createSelector(createProfileState, (state) =>
  state ? state.residence : null
);

export const selectProfileResidenceResponse = createSelector(selectProfileResidenceState, (state) =>
  state ? state.response : null
);

export const selectProfileResidenceProcessing = createSelector(selectProfileResidenceState, (state) =>
  state ? state.processing : null
);

export const selectProfileResidenceProcessed = createSelector(selectProfileResidenceState, (state) =>
  state ? state.processed : null
);

export const selectProfileResidenceFailure = createSelector(selectProfileResidenceState, (state) =>
  state ? state.error : null
);

// email
export const selectProfileEmailState = createSelector(createProfileState, (state) => state?.email);
export const selectProfileEmail = createSelector(selectProfileEmailState, (state) => state?.response);
export const selectProfileEmailIsLoading = createSelector(selectProfileEmailState, (state) => state?.processing);
export const selectProfileEmailError = createSelector(selectProfileEmailState, (state) => state?.error);

// Paperless
export const selectProfilePaperlessState = createSelector(createProfileState, (state) => state?.paperless);
export const selectProfilePaperless = createSelector(selectProfilePaperlessState, (state) => state?.response);

export const selectIsPaperlessEnrollable = createSelector(selectProfilePaperless, (state) =>
  state ? getIsPaperlessEnrollable(Object.values(state)) : undefined
);

export const selectProfilePaperlessError = createSelector(selectProfilePaperlessState, (state) => !!state?.error);
export const selectProfilePaperlessIsLoading = createSelector(selectProfilePaperlessState, (state) => state.processing);
export const selectProfilePaperlessIsLoaded = createSelector(selectProfilePaperlessState, (state) => state.processed);
